import React, { useState } from 'react';
import { PlusIcon, TrashIcon, InfoIcon, PackageIcon } from 'lucide-react';
export function ProjectItemsStep({
  initialData = [],
  onUpdate
}) {
  const [items, setItems] = useState(initialData.length ? initialData : [{
    name: '',
    description: '',
    quantity: 1,
    price: 0
  }]);
  const handleAddItem = () => {
    const newItems = [...items, {
      name: '',
      description: '',
      quantity: 1,
      price: 0
    }];
    setItems(newItems);
    onUpdate(newItems);
  };
  const handleRemoveItem = index => {
    const newItems = items.filter((_, i) => i !== index);
    setItems(newItems);
    onUpdate(newItems);
  };
  const handleItemChange = (index, field, value) => {
    const newItems = [...items];
    newItems[index] = {
      ...newItems[index],
      [field]: value
    };
    setItems(newItems);
    onUpdate(newItems);
  };
  // Calculate total
  const total = items.reduce((sum, item) => sum + (item.price || 0), 0);
  return <div className="space-y-6" data-id="element-4515" data-mp="17pcv6opngez9">
      <div className="text-white text-xl font-medium mb-6" data-id="element-4516" data-mp="17pmoal5zr296">Project Items</div>
      <div className="bg-blue-900/30 rounded-xl p-5 border border-blue-800/30 mb-6" data-id="element-4517" data-mp="12ywfexycwh9q">
        <div className="flex items-start" data-id="element-4518" data-mp="xzjjzotf61vj">
          <InfoIcon size={20} className="text-blue-400 mr-3 mt-0.5" data-id="element-4519" data-mp="y0l38gkl9uoc" />
          <div data-id="element-4520" data-mp="tyhtbwdkiy56">
            <h3 className="text-white font-medium mb-1" data-id="element-4521" data-mp="tyrbixsdg10b">Project Items Guide</h3>
            <p className="text-blue-200 text-sm" data-id="element-4522" data-mp="1qnyz0bcjwk6v">
              Add all the components and services that will be included in this
              project quote. Be specific with descriptions to avoid
              misunderstandings.
            </p>
          </div>
        </div>
      </div>
      <div className="bg-slate-800/50 rounded-xl border border-blue-800/30" data-id="element-4523" data-mp="1cofzg6xt2h66">
        <div className="grid grid-cols-12 gap-4 p-4 border-b border-blue-800/30 text-sm font-medium text-blue-300" data-id="element-4524" data-mp="1cqk0mh4bl22r">
          <div className="col-span-5" data-id="element-4525" data-mp="19aj404r4k43">Item</div>
          <div className="col-span-4" data-id="element-4526" data-mp="18hm3qvlh8z5">Description</div>
          <div className="col-span-1 text-center" data-id="element-4527" data-mp="2qg6c2entmxu">Qty</div>
          <div className="col-span-2 text-right pr-8" data-id="element-4528" data-mp="2qzj74pgdl50">Price</div>
        </div>
        <div className="p-2" data-id="element-4529" data-mp="7ohs4v3h00d0">
          {items.map((item, index) => <div key={index} className="grid grid-cols-12 gap-4 p-2 items-center" data-id="element-4530" data-mp="3pv5vafeymdg1" data-mpi={index}>
              <div className="col-span-5" data-id="element-4531" data-mp="3pxia4jpf87ov">
                <input type="text" value={item.name} onChange={e => handleItemChange(index, 'name', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Item name" data-id="element-4532" data-mp="3tvzj78sejs8x" />
              </div>
              <div className="col-span-4" data-id="element-4533" data-mp="3687uf5podmqr">
                <input type="text" value={item.description} onChange={e => handleItemChange(index, 'description', e.target.value)} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="Brief description" data-id="element-4534" data-mp="365bx9jlnj23d" />
              </div>
              <div className="col-span-1" data-id="element-4535" data-mp="2ij9oap3a00c9">
                <input type="number" value={item.quantity} onChange={e => handleItemChange(index, 'quantity', parseInt(e.target.value))} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg px-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 text-center" min="1" data-id="element-4536" data-mp="2ikbanppqs99a" />
              </div>
              <div className="col-span-1" data-id="element-4537" data-mp="2nkyyy3ml6bzt">
                <div className="relative" data-id="element-4538" data-mp="31hvom1qyxnf4">
                  <span className="absolute left-3 top-2 text-gray-400" data-id="element-4539" data-mp="31gsxpttnbkz7">$</span>
                  <input type="number" value={item.price} onChange={e => handleItemChange(index, 'price', parseFloat(e.target.value))} className="w-full bg-slate-900/50 border border-blue-800/30 rounded-lg pl-7 pr-3 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-500" min="0" step="100" data-id="element-4540" data-mp="2wj19paw4gj0a" />
                </div>
              </div>
              <div className="col-span-1 flex justify-center" data-id="element-4541" data-mp="3fa292015mgkd">
                {items.length > 1 && <button onClick={() => handleRemoveItem(index)} className="p-1.5 rounded-full bg-red-500/20 text-red-400 hover:bg-red-500/40 hover:text-white transition-colors" data-id="element-4542" data-mp="3f87io6745w8w">
                    <TrashIcon size={16} data-id="element-4543" data-mp="1ii4wtcbp9mmf" />
                  </button>}
              </div>
            </div>)}
        </div>
        <div className="p-4 border-t border-blue-800/30" data-id="element-4544" data-mp="1nd21k71y59ti">
          <button onClick={handleAddItem} className="w-full py-2.5 rounded-lg border border-dashed border-blue-500/50 bg-blue-900/20 text-blue-400 hover:bg-blue-900/30 hover:text-blue-300 transition-colors flex items-center justify-center" data-id="element-4545" data-mp="1razrxd7ge1yh">
            <PlusIcon size={18} className="mr-2" data-id="element-4546" data-mp="zmy82sih2qg8" />
            Add Another Item
          </button>
        </div>
      </div>
      {/* Total section */}
      <div className="flex justify-end" data-id="element-4547" data-mp="18mupqa6g2p1s">
        <div className="bg-slate-800/50 rounded-xl p-4 border border-blue-800/30 w-64" data-id="element-4548" data-mp="18jfb18goni0w">
          <div className="flex justify-between items-center text-blue-300 mb-2" data-id="element-4549" data-mp="2f3yef7o0begs">
            <span data-id="element-4550" data-mp="2jzdorpmt2s8g">Subtotal:</span>
            <span className="text-white" data-id="element-4551" data-mp="2k2rqcvnnaxeu">${total.toFixed(2)}</span>
          </div>
          <div className="border-t border-blue-800/30 pt-2 mt-2" data-id="element-4552" data-mp="2u6zu3zcttd8i">
            <div className="flex justify-between items-center" data-id="element-4553" data-mp="2p6u1ogyqfmpd">
              <span className="font-medium text-white" data-id="element-4554" data-mp="2keu610pp3fyl">Total:</span>
              <span className="text-xl font-bold text-white" data-id="element-4555" data-mp="2kczg17zkgxnn">
                ${total.toFixed(2)}
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* Item categories */}
      <div className="bg-slate-800/50 rounded-xl p-5 border border-blue-800/30" data-id="element-4556" data-mp="2bc1b8nhb0m40">
        <div className="flex items-center mb-4" data-id="element-4557" data-mp="26dzrs1fyuks0">
          <PackageIcon size={20} className="text-blue-400 mr-2" data-id="element-4558" data-mp="21foknyh22odh" />
          <h3 className="text-white font-medium" data-id="element-4559" data-mp="21i1b700vq725">Common Project Items</h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3" data-id="element-4560" data-mp="1xgfsuz5kt0kk">
          <button onClick={() => {
          const newItems = [...items, {
            name: 'Center Pivot System',
            description: 'Complete center pivot irrigation system',
            quantity: 1,
            price: 70000
          }];
          setItems(newItems);
          onUpdate(newItems);
        }} className="bg-slate-900/30 hover:bg-slate-900/50 p-3 rounded-lg text-left transition-colors" data-id="element-4561" data-mp="3vtpgsbl80x9v">
            <h4 className="text-white font-medium mb-1" data-id="element-4562" data-mp="1g7520wz82hpk">Center Pivot</h4>
            <p className="text-xs text-blue-300" data-id="element-4563" data-mp="1k7xaho09siks">Complete irrigation system</p>
          </button>
          <button onClick={() => {
          const newItems = [...items, {
            name: 'Pump Station',
            description: 'Water pumping station with controls',
            quantity: 1,
            price: 25000
          }];
          setItems(newItems);
          onUpdate(newItems);
        }} className="bg-slate-900/30 hover:bg-slate-900/50 p-3 rounded-lg text-left transition-colors" data-id="element-4564" data-mp="27xjd6lfupfxj">
            <h4 className="text-white font-medium mb-1" data-id="element-4565" data-mp="nfts6uzjhqu0">Pump Station</h4>
            <p className="text-xs text-blue-300" data-id="element-4566" data-mp="sg955lfwswbg">Water pumping equipment</p>
          </button>
          <button onClick={() => {
          const newItems = [...items, {
            name: 'Control System',
            description: 'Advanced irrigation control system',
            quantity: 1,
            price: 15000
          }];
          setItems(newItems);
          onUpdate(newItems);
        }} className="bg-slate-900/30 hover:bg-slate-900/50 p-3 rounded-lg text-left transition-colors" data-id="element-4567" data-mp="jy63h99t7app">
            <h4 className="text-white font-medium mb-1" data-id="element-4568" data-mp="17oenfs3kz9m">Control System</h4>
            <p className="text-xs text-blue-300" data-id="element-4569" data-mp="3seireaw5zs6j">Automation & monitoring</p>
          </button>
          <button onClick={() => {
          const newItems = [...items, {
            name: 'Installation Service',
            description: 'Professional installation and setup',
            quantity: 1,
            price: 20000
          }];
          setItems(newItems);
          onUpdate(newItems);
        }} className="bg-slate-900/30 hover:bg-slate-900/50 p-3 rounded-lg text-left transition-colors" data-id="element-4570" data-mp="3sco5at95pu0v">
            <h4 className="text-white font-medium mb-1" data-id="element-4571" data-mp="2o4puz91v07c8">Installation</h4>
            <p className="text-xs text-blue-300" data-id="element-4572" data-mp="2o6sssf9974ri">Professional setup service</p>
          </button>
        </div>
      </div>
    </div>;
}